<c3-config-section-box [title]="glycaemiaProfile.label" [icon]="glycaemiaProfile.icon">
  <p config-description>{{ glycaemiaProfile.description }}</p>

  <div [c3ConfigForm]="this">
    <form class="form" [formGroup]="form" #tpForm>
      <!-- insulin_sensitivity_factor -->
      <div class="f-section">
        <div class="f-section-title">
          <span>Fattore di sensibilità insulinico</span>
        </div>
        <div class="f-section-content" [formGroupName]="KEY_insulin_sensitivity_factor">
          <div class="d-flex flex-row justify-start items-baseline gap-16">
            <mat-button-toggle-group
              [value]="insulinSensitivityFactorSelector"
              (change)="insulinSensitivityFactorSelector = $event.source.value"
            >
              <mat-button-toggle [value]="KEY_general">Generale</mat-button-toggle>
              <mat-button-toggle [value]="KEY_specific">Specifico</mat-button-toggle>
            </mat-button-toggle-group>

            <div class="group flex-50" *ngIf="insulinSensitivityFactorSelector === KEY_general">
              <div class="d-flex flex-row flex-wrap">
                <mat-form-field class="field">
                  <mat-label>Generale</mat-label>
                  <input matInput #f type="number" [formControlName]="KEY_general" />
                  <mat-error
                    *ngIf="
                      form
                        .get('insulin_sensitivity_factor.general')
                        ?.getError(SECTION_REQUIRED_ERROR)
                    "
                  >
                    Tutti i campi della sezione devono essere compilati
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div
              class="group flex-50"
              *ngIf="insulinSensitivityFactorSelector === KEY_specific"
              [formGroupName]="KEY_specific"
            >
              <div class="d-flex flex-row">
                <mat-form-field class="field">
                  <mat-label>Giorno</mat-label>
                  <input matInput type="number" [formControlName]="KEY_day" />
                  <mat-error
                    *ngIf="
                      form
                        .get('insulin_sensitivity_factor.specific.day')
                        ?.getError(SECTION_REQUIRED_ERROR)
                    "
                  >
                    Tutti i campi della sezione devono essere compilati
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="field">
                  <mat-label>Notte</mat-label>
                  <input matInput type="number" [formControlName]="KEY_night" />
                  <mat-error
                    *ngIf="
                      form
                        .get('insulin_sensitivity_factor.specific.night')
                        ?.getError(SECTION_REQUIRED_ERROR)
                    "
                  >
                    Tutti i campi della sezione devono essere compilati
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- cho_insulin_ratio -->
      <div class="f-section">
        <div class="f-section-title">
          <span>Rapporto Insulina/Cho</span>
        </div>
        <div class="f-section-content" [formGroupName]="KEY_cho_insulin_ratio">
          <div class="d-flex flex-row justify-start items-baseline gap-16">
            <mat-button-toggle-group
              [value]="insulinChoRatioSelector"
              (change)="insulinChoRatioSelector = $event.source.value"
            >
              <mat-button-toggle [value]="KEY_general">Generale</mat-button-toggle>
              <mat-button-toggle [value]="KEY_specific">Specifico</mat-button-toggle>
            </mat-button-toggle-group>

            <div class="group flex-50" *ngIf="insulinChoRatioSelector === KEY_general">
              <div class="d-flex flex-row flex-wrap">
                <mat-form-field class="field">
                  <mat-label>Generale</mat-label>
                  <input matInput type="number" [formControlName]="KEY_general" />
                  <mat-error
                    *ngIf="form.get('cho_insulin_ratio.general')?.getError(SECTION_REQUIRED_ERROR)"
                  >
                    Tutti i campi della sezione devono essere compilati
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div
              class="group flex-50"
              *ngIf="insulinChoRatioSelector === KEY_specific"
              [formGroupName]="KEY_specific"
            >
              <div class="d-flex flex-row">
                <mat-form-field class="field">
                  <mat-label>Colazione</mat-label>
                  <input matInput type="number" [formControlName]="KEY_breakfast" />
                  <mat-error
                    *ngIf="
                      form
                        .get('cho_insulin_ratio.specific.breakfast')
                        ?.getError(SECTION_REQUIRED_ERROR)
                    "
                  >
                    Tutti i campi della sezione devono essere compilati
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="field">
                  <mat-label>Pranzo</mat-label>
                  <input matInput type="number" [formControlName]="KEY_lunch" />
                  <mat-error
                    *ngIf="
                      form.get('cho_insulin_ratio.specific.lunch')?.getError(SECTION_REQUIRED_ERROR)
                    "
                  >
                    Tutti i campi della sezione devono essere compilati
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="field">
                  <mat-label>Cena</mat-label>
                  <input matInput type="number" [formControlName]="KEY_dinner" />
                  <mat-error
                    *ngIf="
                      form
                        .get('cho_insulin_ratio.specific.dinner')
                        ?.getError(SECTION_REQUIRED_ERROR)
                    "
                  >
                    Tutti i campi della sezione devono essere compilati
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- glycemic_target_ranges -->
      <div class="f-section">
        <div class="f-section-title">
          <span>Range target glicemici</span>
        </div>
        <div class="f-section-content" [formGroupName]="KEY_glycemic_target_ranges">
          <div class="d-flex flex-row justify-start items-start gap-16">
            <mat-button-toggle-group
              [value]="insulinTargetRangeSelector"
              (change)="insulinTargetRangeSelector = $event.source.value"
            >
              <mat-button-toggle [value]="KEY_general">Generale</mat-button-toggle>
              <mat-button-toggle [value]="KEY_specific">Specifico</mat-button-toggle>
            </mat-button-toggle-group>

            <div
              class="group flex-50"
              *ngIf="insulinTargetRangeSelector === KEY_general"
              [formGroupName]="KEY_general"
            >
              <div class="d-flex flex-row flex-wrap">
                <div class="d-flex flex-col flex-wrap">
                  <mat-form-field class="field">
                    <mat-label>Min</mat-label>
                    <input matInput type="number" [formControlName]="KEY_min" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.general.min')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="field">
                    <mat-label>Max</mat-label>
                    <input matInput type="number" [formControlName]="KEY_max" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.general.max')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div
              class="group flex-50"
              *ngIf="insulinTargetRangeSelector === KEY_specific"
              [formGroupName]="KEY_specific"
            >
              <div class="d-flex flex-row flex-wrap">
                <div [formGroupName]="KEY_before_prandial" class="padded flex-33-md">
                  <h4 class="rtg-group-label">Pre-prandiale</h4>

                  <mat-form-field class="field">
                    <mat-label>Min</mat-label>
                    <input matInput type="number" [formControlName]="KEY_min" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.specific.before_prandial.min')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="field">
                    <mat-label>Max</mat-label>
                    <input matInput type="number" [formControlName]="KEY_max" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.specific.before_prandial.max')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>
                </div>

                <div [formGroupName]="KEY_after_prandial" class="padded flex-33-md">
                  <h4 class="rtg-group-label">Post-prandiale</h4>

                  <mat-form-field class="field">
                    <mat-label>Min</mat-label>
                    <input matInput type="number" [formControlName]="KEY_min" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.specific.after_prandial.min')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="field">
                    <mat-label>Max</mat-label>
                    <input matInput type="number" [formControlName]="KEY_max" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.specific.after_prandial.max')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>
                </div>

                <div [formGroupName]="KEY_night" class="padded flex-33-md">
                  <h4 class="rtg-group-label">Notte</h4>

                  <mat-form-field class="field">
                    <mat-label>Min</mat-label>
                    <input matInput type="number" [formControlName]="KEY_min" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.specific.night.min')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="field">
                    <mat-label>Max</mat-label>
                    <input matInput type="number" [formControlName]="KEY_max" />
                    <span matSuffix>mg/dL</span>
                    <mat-error
                      *ngIf="
                        form
                          .get('glycemic_target_ranges.specific.night.max')
                          ?.getError(SECTION_REQUIRED_ERROR)
                      "
                    >
                      Tutti i campi della sezione devono essere compilati
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</c3-config-section-box>
